import React from 'react'
import withWidth from 'material-ui/utils/withWidth'

const fitWidth = Component => {
  class FullWidth extends React.Component {
    state = {
      width: 0,
    }
    resize = () => {
      const offset = ['lg', 'md', 'xl'].indexOf(this.props.width) > -1 ? 96 : 48
      this.setState({ width: window.innerWidth - offset })
    }
    componentWillMount() {
      this.resize()
    }
    componentDidMount() {
      window.addEventListener('resize', this.resize)
    }
    componentWillUnmount() {
      window.removeEventListener('resize', this.resize)
    }
    render() {
      return <Component {...this.props} width={this.state.width} />
    }
  }
  return withWidth()(FullWidth)
}

export default fitWidth



// WEBPACK FOOTER //
// ./src/utils/fitWidth.js